import { faCheckCircle, faCircleQuestion, faTimesCircle } from '@fortawesome/pro-solid-svg-icons';
import { useMemo } from 'react';
// Custom Hook.
// -----------------------------------------------------------------------------
export const useFormGroupExplian = (role) => {
    // Hooks.
    // ---------------------------------------------------------------------------
    const { icon, cssClass } = useMemo(() => {
        if (!role) {
            return { icon: undefined, cssClass: undefined };
        }
        switch (role) {
            case 'error':
                return { icon: faTimesCircle, cssClass: 'fg-explain-error' };
            case 'info':
                return { icon: faCircleQuestion, cssClass: 'fg-explain-info' };
            case 'success':
                return { icon: faCheckCircle, cssClass: 'fg-explain-success' };
            case 'none':
                return {};
            default:
                // eslint-disable-next-line no-case-declarations
                const exhaustiveCheck = role;
                throw new Error(exhaustiveCheck);
        }
    }, [role]);
    // Return.
    // ---------------------------------------------------------------------------
    return { cssClass, icon };
};
//# sourceMappingURL=FormGroupExplain.hooks.js.map